import React from 'react'
import { Translation } from 'react-i18next'

// This can't go into the constant file because it needs to be created dynamically
// As a constant the today's date would always be the same when leaving the app open for several days

export const createDateRanges = (baseDate, dataIds) => [
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.yesterday', 'Yesterday')}
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(1, 'day')
      .startOf('day'),
    endDate: baseDate
      .clone()
      .subtract(1, 'day')
      .endOf('day'),
    dataId: dataIds?.Yesterday,
    rangeType: 'Yesterday'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.thisWeek', 'This Week')}
      </Translation>
    ),
    startDate: baseDate.clone().startOf('week'),
    endDate: baseDate.clone(),
    dataId: dataIds?.ThisWeek,
    rangeType: 'This Week'
  },
  {
    name: (
      <Translation ns="common">
        {t =>
          t('common:CalendarSelect.datePicker.lastSevenDays', 'Last 7 Days')
        }
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(6, 'days')
      .startOf('day'),
    endDate: baseDate.clone(),
    dataId: dataIds?.LastSevenDays,
    rangeType: 'Last 7 Days'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.lastWeek', 'Last Week')}
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(1, 'week')
      .startOf('week'),
    endDate: baseDate
      .clone()
      .subtract(1, 'week')
      .endOf('week'),
    dataId: dataIds?.LastWeek,
    rangeType: 'Last Week'
  },
  {
    name: (
      <Translation ns="common">
        {t =>
          t('common:CalendarSelect.datePicker.lastFourteenDays', 'Last 14 Days')
        }
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(13, 'days')
      .startOf('day'),
    endDate: baseDate.clone(),
    dataId: dataIds?.LastFourteenDays,
    rangeType: 'Last 14 Days'
  },
  {
    name: (
      <Translation ns="common">
        {t =>
          t('common:CalendarSelect.datePicker.lastThirtyDays', 'Last 30 Days')
        }
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(29, 'days')
      .startOf('day'),
    endDate: baseDate.clone(),
    dataId: dataIds?.LastThirtyDays,
    rangeType: 'Last 30 Days'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.lastMonth', 'Last Month')}
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(1, 'month')
      .startOf('month'),
    endDate: baseDate
      .clone()
      .subtract(1, 'month')
      .endOf('month'),
    dataId: dataIds?.LastMonth,
    rangeType: 'Last Month'
  },
  {
    name: (
      <Translation ns="common">
        {t =>
          t('common:CalendarSelect.datePicker.lastNinetyDays', 'Last 90 days')
        }
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(89, 'days')
      .startOf('day'),
    endDate: baseDate.clone(),
    dataId: dataIds?.LastNinetyDays,
    rangeType: 'Last 90 Days'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.lastQuarter', 'Last Quarter')}
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(1, 'quarter')
      .startOf('quarter'),
    endDate: baseDate
      .clone()
      .subtract(1, 'quarter')
      .endOf('quarter'),
    dataId: dataIds?.LastQuarter,
    rangeType: 'Last Quarter'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.1year', '1 Year')}
      </Translation>
    ),
    startDate: baseDate.clone().subtract(365, 'days'),
    endDate: baseDate.clone(),
    dataId: dataIds?.OneYear,
    rangeType: '1 Year'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.lastYear', 'Last Year')}
      </Translation>
    ),
    startDate: baseDate
      .clone()
      .subtract(1, 'year')
      .startOf('year'),
    endDate: baseDate
      .clone()
      .subtract(1, 'year')
      .endOf('year'),
    dataId: dataIds?.LastYear,
    rangeType: 'Last Year'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.mtd', 'MTD')}
      </Translation>
    ),
    startDate: baseDate.clone().startOf('month'),
    endDate: baseDate.clone(),
    dataId: dataIds?.MTD,
    rangeType: 'MTD'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.qtd', 'QTD')}
      </Translation>
    ),
    startDate: baseDate.clone().startOf('quarter'),
    endDate: baseDate.clone(),
    dataId: dataIds?.QTD,
    rangeType: 'QTD'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.ytd', 'YTD')}
      </Translation>
    ),
    startDate: baseDate.clone().startOf('year'),
    endDate: baseDate.clone(),
    dataId: dataIds?.YearToDate,
    rangeType: 'YTD'
  },
  {
    name: (
      <Translation ns="common">
        {t => t('common:CalendarSelect.datePicker.2years', '2 Years')}
      </Translation>
    ),
    startDate: baseDate.clone().subtract(2, 'year'),
    endDate: baseDate.clone(),
    dataId: dataIds?.TwoYears,
    rangeType: '2 Years'
  }
]

export const DEFAULT_RANGE_TYPE = '1 Year'
